import DataTable from "../components/common/DataTable";
import { useQuery } from "@tanstack/react-query";
import { Button, TextInput, Modal, Text, Group, Stack } from "@mantine/core";
import { notifications } from "@mantine/notifications";

import React from "react";
import Head from "../components/common/Head";
import useValidate from "../hooks/useValidate";
import { addLanguage, getLanguage, updateLanguage } from "../utils/api";
import useStore from "../utils/store";

const Languages = () => {
  const [modal, setModal] = React.useState(false);
  
  const user = useStore((state) => state.user);

  const [buttonLoading, setButtonLoading] = React.useState(false);
  const [newGenre, setNewGenre] = React.useState({});
  const { data, isLoading, refetch } = useQuery({
    queryKey: ["languages"],
    queryFn: () => (user?.getAllLanguages ? getLanguage() : []),
  });
  const addNewGenre = async () => {
    if (!newGenre.name) return;
    setButtonLoading(true);
    const [success, response] = newGenre?._id
      ? await updateLanguage(newGenre?._id, newGenre)
      : await addLanguage(newGenre);
    if (success) {
      notifications.show({ message: 
        newGenre?._id
          ? "Language updated successfully"
          : "Language added successfully"
      , color: "green" });
      setModal(false);
      setNewGenre({});
      refetch();
    }
    setButtonLoading(false);
  };
  useValidate();
  React.useEffect(() => {
    refetch();
  }, []);
  return (
    <>
      
      <Head
        title="Language"
        button={user?.addLanguage ? "Add Language" : null}
        onClick={() => setModal(true)}
      />
      <Modal
        opened={modal}
        onClose={() => setModal(false)}
        title={newGenre?._id ? "Update Language" : "Add New Language"}
      >
        <Stack>
          <TextInput
            placeholder="Language Name"
            value={newGenre.name}
            onChange={(e) => setNewGenre({ ...newGenre, name: e.target.value })}
          />
          <Group justify="flex-end">
            <Button variant="default" onClick={() => setModal(false)}>Cancel</Button>
            <Button loading={buttonLoading} onClick={addNewGenre}>
              {newGenre?._id ? "Update" : "Add"}
            </Button>
          </Group>
        </Stack>
      </Modal>
      <DataTable
        footer={
          user?.getAllLanguages
            ? () => null
            : () => (
                <Text c="red" fw={600}>
                  You don't have permission to view this page
                </Text>
              )
        }
        loading={isLoading}
        dataSource={data}
        columns={[
          {
            title: "Genre Name",
            dataIndex: "name",
            key: "name",
          },
          {
            title: "Actions",
            dataIndex: "actions",
            key: "actions",
            render: (text, record) => {
              return (
                <div className="row">
                  {user?.updateLanguage && (
                    <Button
                      onClick={() => {
                        setNewGenre(record);
                        setModal(true);
                      }}
                      variant="filled"
                    >
                      Edit
                    </Button>
                  )}
                </div>
              );
            },
          },
        ]}
      />
    </>
  );
};

export default Languages;
